import styled from 'styled-components';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import checkboxUnchecked from '../../../images/checkbox-unchecked.png'
import checkboxUncheckedFocused from '../../../images/checkbox-unchecked-focused.png'
import checkboxChecked from '../../../images/checkbox-checked.png'
import checkboxCheckedFocused from '../../../images/checkbox-checked-focused.png'
import {FormCheck} from 'react-bootstrap';

export const ModalBody = styled(Modal.Body)`
  padding: 40px 60px;
`

export const ModalClose = styled(Button)`
  position: absolute;
  top: -14px;
  right: -12px;
  padding: 10px;
  background: #fff;
  border-radius: 100%;
  border-width: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: radial-gradient(100% 100% at 0% 0%, rgba(221, 227, 250, 0.99) 0%, rgba(221, 229, 250, 0.4) 100%);
  &:hover{
    box-shadow: none;
    border-radius: 100%;
    border-width: 0;
  }
  &:focus{
    border-width: 0;
    box-shadow: inset 4px 4px 4px rgba(0, 0, 0, 0.15);
    border-radius: 100%;
  }
`

export const StyledImg = styled.img`
  width: 100%;
`;

export const ModalBtn = styled(Button)`
  width: 162px;
  height: 50px;
  background: linear-gradient(90.82deg, #1CCCEF -33.3%, #1C62EF 84.24%);
  border-radius: 8px;
  border-width: 0;

  &:hover{
    background: linear-gradient(90.82deg, #1CCCEF -33.3%, #1C62EF 84.24%);
    box-shadow: -8.49px -8.49px 5px rgba(255, 255, 255, 0.33), 8.17px 8.17px 12px rgba(36, 38, 89, 0.1);
    border-radius: 8px;
    border-width: 0;
  }
  &:focus{
    border-width: 0;
    background: linear-gradient(90.82deg, #1CCCEF -33.3%, #1C62EF 84.24%);
    box-shadow: inset 4px 4px 4px rgba(0, 0, 0, 0.15);
    border-radius: 8px;
  }
`

export const Container = styled.div`
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`

export const Checkbox = styled(FormCheck)`
  display: flex;
  align-items: center;
  justify-content: center;
  & label{
    margin-top: 3px;
    color: #3F1CEF;
  }
  & input{
    appearance: none;
    vertical-align: top;
    height: 30px;
    width: 30px;
    margin-right: 10px;
    display: inline-block;
    position: relative;
    background-color: transparent;
    background-image: url(${checkboxUnchecked});
    background-repeat: no-repeat;
    background-position: center center;
    &:hover{
      background-image: url(${checkboxUncheckedFocused});
      height: 30px;
      width: 30px;
    }
  }
  & input:checked{
    background-image: url(${checkboxChecked});
    &:hover{
      background-image: url(${checkboxCheckedFocused});
      height: 30px;
      width: 30px;
    }
  }
`

export const Banner = styled.img`
  max-width: 100%;
  height: 220px;
`

export const Title = styled.h2`
  font-size: 28px;
  line-height: 40px;
  font-weight: 600;
  font-family: Manrope, sans-serif;
  margin-top: 45px;
  margin-bottom: 25px;
`

export const Paragraph = styled.p`
  font-family: OpenSans, sans-serif;
  font-size: 18px;
  line-height: 30px;
  font-weight: 400;
  margin-bottom: 45px;
`